import { render, staticRenderFns } from "./RemoveUserButton.vue?vue&type=template&id=4fead118"
import script from "./RemoveUserButton.vue?vue&type=script&lang=ts"
export * from "./RemoveUserButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports